import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: '24px 0px !important'
}));

export const TabBoxStyled = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid',
  borderColor: theme.palette.fixed.black
}));
